<template>
  <div class="order">
    <div class="orderTitle">
      <!-- 点餐头部 -->
      <orderTitle />
    </div>
    <div class="orderMain">
      <div class="leftNav">
        <!-- 左边菜谱 -->
        <orderMenu />
      </div>
      <div class="view">
        <!-- 右边菜单 -->
        <SelectedMenu />
      </div>
    </div>
  </div>
</template>

<script>
import orderTitle from "./components/orderTitle.vue";
import orderMenu from "./components/orderMenu.vue";
import SelectedMenu from "./components/SelectedMenu.vue";
export default {
  components: {
    orderTitle,
    orderMenu,
    SelectedMenu,
  },
  created(){
    // console.log(JSON.parse(this.$route.query));
  },
  methods:{
   
  }
};
</script>

<style lang="scss" scoped>
.order {
  display: flex;
  flex-direction: column;
  background: #e7e8f1;
  height: 100%;
  .orderTitle {
    height: 50px;
    width: 100%;
  }
  .orderMain {
    display: flex;
    .leftNav {
      width: 55%;
      max-height: calc(100vh - 50px);
      height: 100%;
      margin-right: 10px;
      // border-radius: 20px;
      position: absolute;
      top: 50px;
      left: 0px;
      background: #fff;
      border: 1px solid #eee;
    }

    .view {
      width: 45%;
      max-height: calc(100vh - 50px);
      height: 100%;
      // border-radius: 20px;
      position: absolute;
      top: 50px;
      border: 1px solid #eee;

      right: 0px;
      background: #fff;
      display: flex;
      flex-direction: column;
    }
  }
}
</style>